module.exports = __webpack_public_path__ + "img/Battery.6dada4e3.jpg";